import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogArticle from "../pages/blog/kakobuy-spreadsheet-ultimate-guide-2026/page";
import BlogClothingFinds from "../pages/blog/best-kakobuy-clothing-finds/page";
import BlogProductListsPro from "../pages/blog/how-to-read-kakobuy-product-lists/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/kakobuy-spreadsheet-ultimate-guide-2026",
    element: <BlogArticle />,
  },
  {
    path: "/blog/best-kakobuy-clothing-finds",
    element: <BlogClothingFinds />,
  },
  {
    path: "/blog/how-to-read-kakobuy-product-lists",
    element: <BlogProductListsPro />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;